import { lazy } from 'react';

export const startupLazyRouteImporters = {
  community() {
    return import('./community/routes');
  },
  customers() {
    return import('./customers');
  },
  pages() {
    return import('./pages');
  },
  dashboard() {
    return import('./dashboard/wrapper');
  },
  inbox() {
    return import('./inbox/react');
  },
  campaigns() {
    return import('./campaigns/react');
  },
  payments() {
    return import('./payments/react');
  },
  calendar() {
    return import('./calendar/react');
  },
  dataCollections() {
    return import('./data-collections/react');
  },
  products() {
    return import('./products/react');
  },
  welcome() {
    return import('./welcome/react');
  },
  skills() {
    return import('./skills/react');
  }
};

export const Community = lazy(startupLazyRouteImporters.community);
export const Customers = lazy(startupLazyRouteImporters.customers);
export const Pages = lazy(startupLazyRouteImporters.pages);
export const Dashboard = lazy(startupLazyRouteImporters.dashboard);
export const Inbox = lazy(startupLazyRouteImporters.inbox);
export const Campaigns = lazy(startupLazyRouteImporters.campaigns);
export const Payments = lazy(startupLazyRouteImporters.payments);
export const Calendar = lazy(startupLazyRouteImporters.calendar);
export const DataCollections = lazy(startupLazyRouteImporters.dataCollections);
export const Products = lazy(startupLazyRouteImporters.products);
export const Welcome = lazy(startupLazyRouteImporters.welcome);
export const Skills = lazy(startupLazyRouteImporters.skills);